import {listView, photoViewConsider} from '../../shared/util';
import {Link} from 'react-router';
import ResultsView from './results-view';
import PropTypes from 'prop-types';
import React from 'react';

import './featured.scss';
// TODO sort by sales first than rentals price descending order
const Listings = ({defaultOptions, listings, name}) => {
  if (!listings || !listings.length > 0) {
    return null;
  }
  const showOptions =  photoViewConsider
  const viewAllButton = listings.length >= 2 ? (
    <div className="view-all">
      <Link className="aw-button" to={name ? "/solds/sales" :"/listings/sales"} >
        View All
      </Link>
    </div>
  ) : null;

  return (
    <div className="featured-listings">
      <h2 className="wide-header">
        {name ? name :`Exclusive Listings`}
      </h2>
      <ResultsView listings={listings} options={showOptions} consider={true}/>
      {viewAllButton}
    </div>
  );
};

Listings.propTypes = {
  listings: PropTypes.array
};

export default Listings;



// WEBPACK FOOTER //
// ./src/components/homepage/featured/listings.js